<div class="modal-content">
  <div class="modal-header">
    <h6 class="modal-title fw-bold">Duplicate partner</h6>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="modal-body">
      <div class="mb-3">
        <label for="company-name-input" class="form-label small fw-bold">Company Name</label>
        <input formControlName="companyName" type="text" class="form-control" id="company-name-input">
      </div>
    </div>

    <div class="modal-footer bg-tertiary">
      <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Cancel</button>

      <button [disabled]="invalid()" type="submit" class="btn btn-primary fw-bold">
        Duplicate
      </button>
    </div>
  </form>
</div>
